export default <const>[
  {
    id: 'ball_001',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_001_01',
  },
  {
    id: 'ball_002',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_002_01',
  },
  {
    id: 'ball_003',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_003_01',
  },
  {
    id: 'ball_004',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_004_01',
  },
  {
    id: 'ball_005',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_005_01',
  },
  {
    id: 'ball_006',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_006_01',
  },
  {
    id: 'ball_007',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_007_01',
  },
  {
    id: 'ball_008',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_008_01',
  },
  {
    id: 'ball_009',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_009_01',
  },
  {
    id: 'ball_010',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'ball_010_01',
  },
  {
    id: 'ball_011',
    pet_id: 'ball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'ball_011_01',
  },
  {
    id: 'ball_012',
    pet_id: 'ball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'ball_012_01',
  },
  {
    id: 'ball_013',
    pet_id: 'ball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'ball_013_01',
  },
  {
    id: 'ball_014',
    pet_id: 'ball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'ball_014_01',
  },
  {
    id: 'ball_015',
    pet_id: 'ball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'ball_015_01',
  },
  {
    id: 'ball_016',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'ball_016_01',
  },
  {
    id: 'ball_017',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'ball_017_01',
  },
  {
    id: 'ball_018',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'ball_018_01',
  },
  {
    id: 'ball_019',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'ball_019_01',
  },
  {
    id: 'ball_020',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'ball_020_01',
  },
  {
    id: 'ball_021',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'ball_021_01',
  },
  {
    id: 'ball_022',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'ball_022_01',
  },
  {
    id: 'ball_023',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'ball_023_01',
  },
  {
    id: 'ball_024',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'ball_024_01',
  },
  {
    id: 'ball_025',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'ball_025_01',
  },
  {
    id: 'ball_026',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'ball_026_01',
  },
  {
    id: 'ball_027',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'ball_027_01',
  },
  {
    id: 'ball_028',
    pet_id: 'ball',
    scenes: ['normal_chat'],
    pet_states: ['evolving'],
    script_id: 'ball_028_01',
  },
  {
    id: 'ball_029',
    pet_id: 'ball',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'ball_029_01',
  },
  {
    id: 'ball_030',
    pet_id: 'ball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'ball_030_01',
  },
  {
    id: 'ball_031',
    pet_id: 'ball',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'ball_031_01',
  },
  {
    id: 'ball_032',
    pet_id: 'ball',
    scenes: ['had_visitor'],
    script_id: 'ball_032_01',
  },
  {
    id: 'ball_033',
    pet_id: 'ball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['play_place'],
    script_id: 'ball_033_01',
  },
  {
    id: 'ball_034',
    pet_id: 'ball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['fav_snack'],
    script_id: 'ball_034_01',
  },
  {
    id: 'ball_035',
    pet_id: 'ball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['ocean_or_mountains'],
    script_id: 'ball_035_01',
  },
  {
    id: 'ball_036',
    pet_id: 'ball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['enjoy_playing'],
    script_id: 'ball_036_01',
  },
  {
    id: 'ball_037',
    pet_id: 'ball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['boke_or_tsukkomi'],
    script_id: 'ball_037_01',
  },
  {
    id: 'ball_038',
    pet_id: 'ball',
    scenes: ['initial_greetings'],
    script_id: 'ball_038_01',
  },
  {
    id: 'ball_039',
    pet_id: 'ball',
    scenes: ['friend_greetings'],
    script_id: 'ball_039_01',
  },
  {
    id: 'ball_040',
    pet_id: 'ball',
    scenes: ['friend_welcome'],
    script_id: 'ball_040_01',
  },
  {
    id: 'ball_041',
    pet_id: 'ball',
    scenes: ['friend_appreciation'],
    script_id: 'ball_041_01',
  },
  {
    id: 'ball_042',
    pet_id: 'ball',
    scenes: ['friend_goodby'],
    script_id: 'ball_042_01',
  },
  {
    id: 'ball_043',
    pet_id: 'ball',
    scenes: ['friend_farewell'],
    script_id: 'ball_043_01',
  },
  {
    id: 'ball_044',
    pet_id: 'ball',
    scenes: ['friend_kickedout'],
    script_id: 'ball_044_01',
  },
  {
    id: 'ball_045',
    pet_id: 'ball',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'ball_045_01',
  },
  {
    id: 'ball_046',
    pet_id: 'ball',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'ball_046_01',
  },
  {
    id: 'ball_047',
    pet_id: 'ball',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'ball_047_01',
  },
  {
    id: 'ball_048',
    pet_id: 'ball',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'ball_048_01',
  },
  {
    id: 'ball_049',
    pet_id: 'ball',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'ball_049_01',
  },
  {
    id: 'ball_050',
    pet_id: 'ball',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'ball_050_01',
  },
  {
    id: 'ball_051',
    pet_id: 'ball',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'ball_051_01',
  },
  {
    id: 'ball_052',
    pet_id: 'ball',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'ball_052_01',
  },
  {
    id: 'ball_053',
    pet_id: 'ball',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'ball_053_01',
  },
  {
    id: 'ball_054',
    pet_id: 'ball',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'ball_054_01',
  },
  {
    id: 'crab_001',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_001_01',
  },
  {
    id: 'crab_002',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_002_01',
  },
  {
    id: 'crab_003',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_003_01',
  },
  {
    id: 'crab_004',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_004_01',
  },
  {
    id: 'crab_005',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_005_01',
  },
  {
    id: 'crab_006',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_006_01',
  },
  {
    id: 'crab_007',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_007_01',
  },
  {
    id: 'crab_008',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_008_01',
  },
  {
    id: 'crab_009',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_009_01',
  },
  {
    id: 'crab_010',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_010_01',
  },
  {
    id: 'crab_011',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_011_01',
  },
  {
    id: 'crab_012',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_012_01',
  },
  {
    id: 'crab_013',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_013_01',
  },
  {
    id: 'crab_014',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_014_01',
  },
  {
    id: 'crab_015',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_015_01',
  },
  {
    id: 'crab_016',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_016_01',
  },
  {
    id: 'crab_017',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_017_01',
  },
  {
    id: 'crab_018',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_018_01',
  },
  {
    id: 'crab_019',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_019_01',
  },
  {
    id: 'crab_020',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_020_01',
  },
  {
    id: 'crab_021',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_021_01',
  },
  {
    id: 'crab_022',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_022_01',
  },
  {
    id: 'crab_023',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_023_01',
  },
  {
    id: 'crab_024',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_024_01',
  },
  {
    id: 'crab_025',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_025_01',
  },
  {
    id: 'crab_026',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_026_01',
  },
  {
    id: 'crab_027',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_027_01',
  },
  {
    id: 'crab_028',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_028_01',
  },
  {
    id: 'crab_029',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_029_01',
  },
  {
    id: 'crab_030',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_030_01',
  },
  {
    id: 'crab_031',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_031_01',
  },
  {
    id: 'crab_032',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_032_01',
  },
  {
    id: 'crab_033',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_033_01',
  },
  {
    id: 'crab_034',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_034_01',
  },
  {
    id: 'crab_035',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_035_01',
  },
  {
    id: 'crab_036',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_036_01',
  },
  {
    id: 'crab_037',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_037_01',
  },
  {
    id: 'crab_038',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_038_01',
  },
  {
    id: 'crab_039',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_039_01',
  },
  {
    id: 'crab_040',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_040_01',
  },
  {
    id: 'crab_041',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_041_01',
  },
  {
    id: 'crab_042',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'crab_042_01',
  },
  {
    id: 'crab_043',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_043_01',
  },
  {
    id: 'crab_044',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_044_01',
  },
  {
    id: 'crab_045',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_045_01',
  },
  {
    id: 'crab_046',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_046_01',
  },
  {
    id: 'crab_047',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_047_01',
  },
  {
    id: 'crab_048',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_048_01',
  },
  {
    id: 'crab_049',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_049_01',
  },
  {
    id: 'crab_050',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_050_01',
  },
  {
    id: 'crab_051',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_051_01',
  },
  {
    id: 'crab_052',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_052_01',
  },
  {
    id: 'crab_053',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_053_01',
  },
  {
    id: 'crab_054',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_054_01',
  },
  {
    id: 'crab_055',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_055_01',
  },
  {
    id: 'crab_056',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_056_01',
  },
  {
    id: 'crab_057',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_057_01',
  },
  {
    id: 'crab_058',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_058_01',
  },
  {
    id: 'crab_059',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_059_01',
  },
  {
    id: 'crab_060',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_060_01',
  },
  {
    id: 'crab_061',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_061_01',
  },
  {
    id: 'crab_062',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_062_01',
  },
  {
    id: 'crab_063',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'crab_063_01',
  },
  {
    id: 'crab_064',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'crab_064_01',
  },
  {
    id: 'crab_065',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'crab_065_01',
  },
  {
    id: 'crab_066',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'crab_066_01',
  },
  {
    id: 'crab_067',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'crab_067_01',
  },
  {
    id: 'crab_068',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'crab_068_01',
  },
  {
    id: 'crab_069',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'crab_069_01',
  },
  {
    id: 'crab_070',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'crab_070_01',
  },
  {
    id: 'crab_071',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'crab_071_01',
  },
  {
    id: 'crab_072',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'crab_072_01',
  },
  {
    id: 'crab_073',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'crab_073_01',
  },
  {
    id: 'crab_074',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'crab_074_01',
  },
  {
    id: 'crab_075',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'crab_075_01',
  },
  {
    id: 'crab_076',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'crab_076_01',
  },
  {
    id: 'crab_077',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'crab_077_01',
  },
  {
    id: 'crab_078',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'crab_078_01',
  },
  {
    id: 'crab_079',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'crab_079_01',
  },
  {
    id: 'crab_080',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'crab_080_01',
  },
  {
    id: 'crab_081',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'crab_081_01',
  },
  {
    id: 'crab_082',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'crab_082_01',
  },
  {
    id: 'crab_083',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'crab_083_01',
  },
  {
    id: 'crab_084',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'crab_084_01',
  },
  {
    id: 'crab_085',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'crab_085_01',
  },
  {
    id: 'crab_086',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'crab_086_01',
  },
  {
    id: 'crab_087',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['evolving'],
    script_id: 'crab_087_01',
  },
  {
    id: 'crab_088',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'crab_088_01',
  },
  {
    id: 'crab_089',
    pet_id: 'crab',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'crab_089_01',
  },
  {
    id: 'crab_090',
    pet_id: 'crab',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'crab_090_01',
  },
  {
    id: 'crab_091',
    pet_id: 'crab',
    scenes: ['had_visitor'],
    script_id: 'crab_091_01',
  },
  {
    id: 'crab_092',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['rainy_day_activity'],
    script_id: 'crab_092_01',
  },
  {
    id: 'crab_093',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['childhood_nickname'],
    script_id: 'crab_093_01',
  },
  {
    id: 'crab_094',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['speciality'],
    script_id: 'crab_094_01',
  },
  {
    id: 'crab_095',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['interesting_book'],
    script_id: 'crab_095_01',
  },
  {
    id: 'crab_096',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['health_tips'],
    script_id: 'crab_096_01',
  },
  {
    id: 'crab_097',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['future_dream'],
    script_id: 'crab_097_01',
  },
  {
    id: 'crab_098',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['happy_moment'],
    script_id: 'crab_098_01',
  },
  {
    id: 'crab_099',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['how_old_to_go_back'],
    script_id: 'crab_099_01',
  },
  {
    id: 'crab_100',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['cure_cold'],
    script_id: 'crab_100_01',
  },
  {
    id: 'crab_101',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_music'],
    script_id: 'crab_101_01',
  },
  {
    id: 'crab_102',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['long_run_or_short_run'],
    script_id: 'crab_102_01',
  },
  {
    id: 'crab_103',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['no_fat_or_good_skin'],
    script_id: 'crab_103_01',
  },
  {
    id: 'crab_104',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['pe_or_music'],
    script_id: 'crab_104_01',
  },
  {
    id: 'crab_105',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['give_or_given'],
    script_id: 'crab_105_01',
  },
  {
    id: 'crab_106',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['head_or_body'],
    script_id: 'crab_106_01',
  },
  {
    id: 'crab_107',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['eat_or_not_eat_broccoli'],
    script_id: 'crab_107_01',
  },
  {
    id: 'crab_108',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['wait_or_make_wait'],
    script_id: 'crab_108_01',
  },
  {
    id: 'crab_109',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['long_hair_or_short_hair'],
    script_id: 'crab_109_01',
  },
  {
    id: 'crab_110',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['first_in_karaoke'],
    script_id: 'crab_110_01',
  },
  {
    id: 'crab_111',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['summer_or_winter'],
    script_id: 'crab_111_01',
  },
  {
    id: 'crab_112',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    script_id: 'crab_112_01',
  },
  {
    id: 'crab_113',
    pet_id: 'crab',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    script_id: 'crab_113_01',
  },
  {
    id: 'crab_114',
    pet_id: 'crab',
    scenes: ['initial_greetings'],
    script_id: 'crab_114_01',
  },
  {
    id: 'crab_115',
    pet_id: 'crab',
    scenes: ['friend_greetings'],
    script_id: 'crab_115_01',
  },
  {
    id: 'crab_116',
    pet_id: 'crab',
    scenes: ['friend_welcome'],
    script_id: 'crab_116_01',
  },
  {
    id: 'crab_117',
    pet_id: 'crab',
    scenes: ['friend_appreciation'],
    script_id: 'crab_117_01',
  },
  {
    id: 'crab_118',
    pet_id: 'crab',
    scenes: ['friend_goodby'],
    script_id: 'crab_118_01',
  },
  {
    id: 'crab_119',
    pet_id: 'crab',
    scenes: ['friend_farewell'],
    script_id: 'crab_119_01',
  },
  {
    id: 'crab_120',
    pet_id: 'crab',
    scenes: ['friend_kickedout'],
    script_id: 'crab_120_01',
  },
  {
    id: 'crab_121',
    pet_id: 'crab',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'crab_121_01',
  },
  {
    id: 'crab_122',
    pet_id: 'crab',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'crab_122_01',
  },
  {
    id: 'crab_123',
    pet_id: 'crab',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'crab_123_01',
  },
  {
    id: 'crab_124',
    pet_id: 'crab',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'crab_124_01',
  },
  {
    id: 'crab_125',
    pet_id: 'crab',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'crab_125_01',
  },
  {
    id: 'crab_126',
    pet_id: 'crab',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'crab_126_01',
  },
  {
    id: 'crab_127',
    pet_id: 'crab',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'crab_127_01',
  },
  {
    id: 'crab_128',
    pet_id: 'crab',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'crab_128_01',
  },
  {
    id: 'crab_129',
    pet_id: 'crab',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'crab_129_01',
  },
  {
    id: 'crab_130',
    pet_id: 'crab',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'crab_130_01',
  },
  {
    id: 'dog_001',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_001_01',
  },
  {
    id: 'dog_002',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_002_01',
  },
  {
    id: 'dog_003',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_003_01',
  },
  {
    id: 'dog_004',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_004_01',
  },
  {
    id: 'dog_005',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_005_01',
  },
  {
    id: 'dog_006',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_006_01',
  },
  {
    id: 'dog_007',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_007_01',
  },
  {
    id: 'dog_008',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_008_01',
  },
  {
    id: 'dog_009',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_009_01',
  },
  {
    id: 'dog_010',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_010_01',
  },
  {
    id: 'dog_011',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_011_01',
  },
  {
    id: 'dog_012',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_012_01',
  },
  {
    id: 'dog_013',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_013_01',
  },
  {
    id: 'dog_014',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_014_01',
  },
  {
    id: 'dog_015',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_015_01',
  },
  {
    id: 'dog_016',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_016_01',
  },
  {
    id: 'dog_017',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_017_01',
  },
  {
    id: 'dog_018',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_018_01',
  },
  {
    id: 'dog_019',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_019_01',
  },
  {
    id: 'dog_020',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_020_01',
  },
  {
    id: 'dog_021',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_021_01',
  },
  {
    id: 'dog_022',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_022_01',
  },
  {
    id: 'dog_023',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_023_01',
  },
  {
    id: 'dog_024',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_024_01',
  },
  {
    id: 'dog_025',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_025_01',
  },
  {
    id: 'dog_026',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_026_01',
  },
  {
    id: 'dog_027',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_027_01',
  },
  {
    id: 'dog_028',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_028_01',
  },
  {
    id: 'dog_029',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_029_01',
  },
  {
    id: 'dog_030',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_030_01',
  },
  {
    id: 'dog_031',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'dog_031_01',
  },
  {
    id: 'dog_032',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'dog_032_01',
  },
  {
    id: 'dog_033',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'dog_033_01',
  },
  {
    id: 'dog_034',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'dog_034_01',
  },
  {
    id: 'dog_035',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'dog_035_01',
  },
  {
    id: 'dog_036',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'dog_036_01',
  },
  {
    id: 'dog_037',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'dog_037_01',
  },
  {
    id: 'dog_038',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'dog_038_01',
  },
  {
    id: 'dog_039',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'dog_039_01',
  },
  {
    id: 'dog_040',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'dog_040_01',
  },
  {
    id: 'dog_041',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'dog_041_01',
  },
  {
    id: 'dog_042',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'dog_042_01',
  },
  {
    id: 'dog_043',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['evolving'],
    script_id: 'dog_043_01',
  },
  {
    id: 'dog_044',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_044_01',
  },
  {
    id: 'dog_045',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_045_01',
  },
  {
    id: 'dog_046',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_046_01',
  },
  {
    id: 'dog_047',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_047_01',
  },
  {
    id: 'dog_048',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_048_01',
  },
  {
    id: 'dog_049',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_049_01',
  },
  {
    id: 'dog_050',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_050_01',
  },
  {
    id: 'dog_051',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_051_01',
  },
  {
    id: 'dog_052',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_052_01',
  },
  {
    id: 'dog_053',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_053_01',
  },
  {
    id: 'dog_054',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_054_01',
  },
  {
    id: 'dog_055',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_055_01',
  },
  {
    id: 'dog_056',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_056_01',
  },
  {
    id: 'dog_057',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_057_01',
  },
  {
    id: 'dog_058',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_058_01',
  },
  {
    id: 'dog_059',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_059_01',
  },
  {
    id: 'dog_060',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_060_01',
  },
  {
    id: 'dog_061',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_061_01',
  },
  {
    id: 'dog_062',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_062_01',
  },
  {
    id: 'dog_063',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_063_01',
  },
  {
    id: 'dog_064',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_064_01',
  },
  {
    id: 'dog_065',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'dog_065_01',
  },
  {
    id: 'dog_066',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_066_01',
  },
  {
    id: 'dog_067',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_067_01',
  },
  {
    id: 'dog_068',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_068_01',
  },
  {
    id: 'dog_069',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_069_01',
  },
  {
    id: 'dog_070',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_070_01',
  },
  {
    id: 'dog_071',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_071_01',
  },
  {
    id: 'dog_072',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_072_01',
  },
  {
    id: 'dog_073',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_073_01',
  },
  {
    id: 'dog_074',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_074_01',
  },
  {
    id: 'dog_075',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_075_01',
  },
  {
    id: 'dog_076',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'dog_076_01',
  },
  {
    id: 'dog_077',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'dog_077_01',
  },
  {
    id: 'dog_078',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'dog_078_01',
  },
  {
    id: 'dog_079',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'dog_079_01',
  },
  {
    id: 'dog_080',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'dog_080_01',
  },
  {
    id: 'dog_081',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'dog_081_01',
  },
  {
    id: 'dog_082',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'dog_082_01',
  },
  {
    id: 'dog_083',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'dog_083_01',
  },
  {
    id: 'dog_084',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'dog_084_01',
  },
  {
    id: 'dog_085',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'dog_085_01',
  },
  {
    id: 'dog_086',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'dog_086_01',
  },
  {
    id: 'dog_087',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'dog_087_01',
  },
  {
    id: 'dog_088',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'dog_088_01',
  },
  {
    id: 'dog_089',
    pet_id: 'dog',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'dog_089_01',
  },
  {
    id: 'dog_090',
    pet_id: 'dog',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'dog_090_01',
  },
  {
    id: 'dog_091',
    pet_id: 'dog',
    scenes: ['had_visitor'],
    script_id: 'dog_091_01',
  },
  {
    id: 'dog_092',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['autumn_fruit'],
    script_id: 'dog_092_01',
  },
  {
    id: 'dog_093',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['childhood_game'],
    script_id: 'dog_093_01',
  },
  {
    id: 'dog_094',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_place'],
    script_id: 'dog_094_01',
  },
  {
    id: 'dog_095',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['best_buy'],
    script_id: 'dog_095_01',
  },
  {
    id: 'dog_096',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['recent_fave'],
    script_id: 'dog_096_01',
  },
  {
    id: 'dog_097',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['compound_word'],
    script_id: 'dog_097_01',
  },
  {
    id: 'dog_098',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['reincarnation'],
    script_id: 'dog_098_01',
  },
  {
    id: 'dog_099',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['body_part'],
    script_id: 'dog_099_01',
  },
  {
    id: 'dog_100',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['similar_celebrities'],
    script_id: 'dog_100_01',
  },
  {
    id: 'dog_101',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['summer_menu'],
    script_id: 'dog_101_01',
  },
  {
    id: 'dog_102',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['hot_or_cold'],
    script_id: 'dog_102_01',
  },
  {
    id: 'dog_103',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['spring_or_fall'],
    script_id: 'dog_103_01',
  },
  {
    id: 'dog_104',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['care_or_cared'],
    script_id: 'dog_104_01',
  },
  {
    id: 'dog_105',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['fortune_telling'],
    script_id: 'dog_105_01',
  },
  {
    id: 'dog_106',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['remember_face_and_name'],
    script_id: 'dog_106_01',
  },
  {
    id: 'dog_107',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['same_or_opposite_gender'],
    script_id: 'dog_107_01',
  },
  {
    id: 'dog_108',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['solo_yakiniku'],
    script_id: 'dog_108_01',
  },
  {
    id: 'dog_109',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['manga_or_anime'],
    script_id: 'dog_109_01',
  },
  {
    id: 'dog_110',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['tooth_paste'],
    script_id: 'dog_110_01',
  },
  {
    id: 'dog_111',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['spicy_food'],
    script_id: 'dog_111_01',
  },
  {
    id: 'dog_112',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['sensitive_to_fads'],
    script_id: 'dog_112_01',
  },
  {
    id: 'dog_113',
    pet_id: 'dog',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['everyone_or_only_you'],
    script_id: 'dog_113_01',
  },
  {
    id: 'dog_114',
    pet_id: 'dog',
    scenes: ['initial_greetings'],
    script_id: 'dog_114_01',
  },
  {
    id: 'dog_115',
    pet_id: 'dog',
    scenes: ['friend_greetings'],
    script_id: 'dog_115_01',
  },
  {
    id: 'dog_116',
    pet_id: 'dog',
    scenes: ['friend_welcome'],
    script_id: 'dog_116_01',
  },
  {
    id: 'dog_117',
    pet_id: 'dog',
    scenes: ['friend_appreciation'],
    script_id: 'dog_117_01',
  },
  {
    id: 'dog_118',
    pet_id: 'dog',
    scenes: ['friend_goodby'],
    script_id: 'dog_118_01',
  },
  {
    id: 'dog_119',
    pet_id: 'dog',
    scenes: ['friend_farewell'],
    script_id: 'dog_119_01',
  },
  {
    id: 'dog_120',
    pet_id: 'dog',
    scenes: ['friend_kickedout'],
    script_id: 'dog_120_01',
  },
  {
    id: 'dog_121',
    pet_id: 'dog',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'dog_121_01',
  },
  {
    id: 'dog_122',
    pet_id: 'dog',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'dog_122_01',
  },
  {
    id: 'dog_123',
    pet_id: 'dog',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'dog_123_01',
  },
  {
    id: 'dog_124',
    pet_id: 'dog',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'dog_124_01',
  },
  {
    id: 'dog_125',
    pet_id: 'dog',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'dog_125_01',
  },
  {
    id: 'dog_126',
    pet_id: 'dog',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'dog_126_01',
  },
  {
    id: 'dog_127',
    pet_id: 'dog',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'dog_127_01',
  },
  {
    id: 'dog_128',
    pet_id: 'dog',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'dog_128_01',
  },
  {
    id: 'dog_129',
    pet_id: 'dog',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'dog_129_01',
  },
  {
    id: 'dog_130',
    pet_id: 'dog',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'dog_130_01',
  },
  {
    id: 'starball_001',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_001_01',
  },
  {
    id: 'starball_002',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_002_01',
  },
  {
    id: 'starball_003',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_003_01',
  },
  {
    id: 'starball_004',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_004_01',
  },
  {
    id: 'starball_005',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_005_01',
  },
  {
    id: 'starball_006',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_006_01',
  },
  {
    id: 'starball_007',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_007_01',
  },
  {
    id: 'starball_008',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_008_01',
  },
  {
    id: 'starball_009',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_009_01',
  },
  {
    id: 'starball_010',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'starball_010_01',
  },
  {
    id: 'starball_011',
    pet_id: 'starball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'starball_011_01',
  },
  {
    id: 'starball_012',
    pet_id: 'starball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'starball_012_01',
  },
  {
    id: 'starball_013',
    pet_id: 'starball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'starball_013_01',
  },
  {
    id: 'starball_014',
    pet_id: 'starball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'starball_014_01',
  },
  {
    id: 'starball_015',
    pet_id: 'starball',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'starball_015_01',
  },
  {
    id: 'starball_016',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'starball_016_01',
  },
  {
    id: 'starball_017',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'starball_017_01',
  },
  {
    id: 'starball_018',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'starball_018_01',
  },
  {
    id: 'starball_019',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'starball_019_01',
  },
  {
    id: 'starball_020',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'starball_020_01',
  },
  {
    id: 'starball_021',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'starball_021_01',
  },
  {
    id: 'starball_022',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'starball_022_01',
  },
  {
    id: 'starball_023',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'starball_023_01',
  },
  {
    id: 'starball_024',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'starball_024_01',
  },
  {
    id: 'starball_025',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'starball_025_01',
  },
  {
    id: 'starball_026',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'starball_026_01',
  },
  {
    id: 'starball_027',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'starball_027_01',
  },
  {
    id: 'starball_028',
    pet_id: 'starball',
    scenes: ['normal_chat'],
    pet_states: ['evolving'],
    script_id: 'starball_028_01',
  },
  {
    id: 'starball_029',
    pet_id: 'starball',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'starball_029_01',
  },
  {
    id: 'starball_030',
    pet_id: 'starball',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'starball_030_01',
  },
  {
    id: 'starball_031',
    pet_id: 'starball',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'starball_031_01',
  },
  {
    id: 'starball_032',
    pet_id: 'starball',
    scenes: ['had_visitor'],
    script_id: 'starball_032_01',
  },
  {
    id: 'starball_033',
    pet_id: 'starball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['fav_anime'],
    script_id: 'starball_033_01',
  },
  {
    id: 'starball_034',
    pet_id: 'starball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['sleep_well'],
    script_id: 'starball_034_01',
  },
  {
    id: 'starball_035',
    pet_id: 'starball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['plum_or_fish'],
    script_id: 'starball_035_01',
  },
  {
    id: 'starball_036',
    pet_id: 'starball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['sunny_side_up'],
    script_id: 'starball_036_01',
  },
  {
    id: 'starball_037',
    pet_id: 'starball',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['safari_or_aurora'],
    script_id: 'starball_037_01',
  },
  {
    id: 'starball_038',
    pet_id: 'starball',
    scenes: ['initial_greetings'],
    script_id: 'starball_038_01',
  },
  {
    id: 'starball_039',
    pet_id: 'starball',
    scenes: ['friend_greetings'],
    script_id: 'starball_039_01',
  },
  {
    id: 'starball_040',
    pet_id: 'starball',
    scenes: ['friend_welcome'],
    script_id: 'starball_040_01',
  },
  {
    id: 'starball_041',
    pet_id: 'starball',
    scenes: ['friend_appreciation'],
    script_id: 'starball_041_01',
  },
  {
    id: 'starball_042',
    pet_id: 'starball',
    scenes: ['friend_goodby'],
    script_id: 'starball_042_01',
  },
  {
    id: 'starball_043',
    pet_id: 'starball',
    scenes: ['friend_farewell'],
    script_id: 'starball_043_01',
  },
  {
    id: 'starball_044',
    pet_id: 'starball',
    scenes: ['friend_kickedout'],
    script_id: 'starball_044_01',
  },
  {
    id: 'starball_045',
    pet_id: 'starball',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'starball_045_01',
  },
  {
    id: 'starball_046',
    pet_id: 'starball',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'starball_046_01',
  },
  {
    id: 'starball_047',
    pet_id: 'starball',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'starball_047_01',
  },
  {
    id: 'starball_048',
    pet_id: 'starball',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'starball_048_01',
  },
  {
    id: 'starball_049',
    pet_id: 'starball',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'starball_049_01',
  },
  {
    id: 'starball_050',
    pet_id: 'starball',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'starball_050_01',
  },
  {
    id: 'starball_051',
    pet_id: 'starball',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'starball_051_01',
  },
  {
    id: 'starball_052',
    pet_id: 'starball',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'starball_052_01',
  },
  {
    id: 'starball_053',
    pet_id: 'starball',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'starball_053_01',
  },
  {
    id: 'starball_054',
    pet_id: 'starball',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'starball_054_01',
  },
  {
    id: 'hamster_001',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_001_01',
  },
  {
    id: 'hamster_002',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_002_01',
  },
  {
    id: 'hamster_003',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_003_01',
  },
  {
    id: 'hamster_004',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_004_01',
  },
  {
    id: 'hamster_005',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_005_01',
  },
  {
    id: 'hamster_006',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_006_01',
  },
  {
    id: 'hamster_007',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_007_01',
  },
  {
    id: 'hamster_008',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_008_01',
  },
  {
    id: 'hamster_009',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_009_01',
  },
  {
    id: 'hamster_010',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_010_01',
  },
  {
    id: 'hamster_011',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_011_01',
  },
  {
    id: 'hamster_012',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_012_01',
  },
  {
    id: 'hamster_013',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_013_01',
  },
  {
    id: 'hamster_014',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_014_01',
  },
  {
    id: 'hamster_015',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_015_01',
  },
  {
    id: 'hamster_016',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_016_01',
  },
  {
    id: 'hamster_017',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_017_01',
  },
  {
    id: 'hamster_018',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_018_01',
  },
  {
    id: 'hamster_019',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_019_01',
  },
  {
    id: 'hamster_020',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_020_01',
  },
  {
    id: 'hamster_021',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_021_01',
  },
  {
    id: 'hamster_022',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_022_01',
  },
  {
    id: 'hamster_023',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_023_01',
  },
  {
    id: 'hamster_024',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_024_01',
  },
  {
    id: 'hamster_025',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_025_01',
  },
  {
    id: 'hamster_026',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_026_01',
  },
  {
    id: 'hamster_027',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_027_01',
  },
  {
    id: 'hamster_028',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_028_01',
  },
  {
    id: 'hamster_029',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_029_01',
  },
  {
    id: 'hamster_030',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_030_01',
  },
  {
    id: 'hamster_031',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_031_01',
  },
  {
    id: 'hamster_032',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_032_01',
  },
  {
    id: 'hamster_033',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_033_01',
  },
  {
    id: 'hamster_034',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_034_01',
  },
  {
    id: 'hamster_035',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_035_01',
  },
  {
    id: 'hamster_036',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_036_01',
  },
  {
    id: 'hamster_037',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_037_01',
  },
  {
    id: 'hamster_038',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_038_01',
  },
  {
    id: 'hamster_039',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_039_01',
  },
  {
    id: 'hamster_040',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_040_01',
  },
  {
    id: 'hamster_041',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_041_01',
  },
  {
    id: 'hamster_042',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'hamster_042_01',
  },
  {
    id: 'hamster_043',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_043_01',
  },
  {
    id: 'hamster_044',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_044_01',
  },
  {
    id: 'hamster_045',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_045_01',
  },
  {
    id: 'hamster_046',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_046_01',
  },
  {
    id: 'hamster_047',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_047_01',
  },
  {
    id: 'hamster_048',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_048_01',
  },
  {
    id: 'hamster_049',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_049_01',
  },
  {
    id: 'hamster_050',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_050_01',
  },
  {
    id: 'hamster_051',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_051_01',
  },
  {
    id: 'hamster_052',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_052_01',
  },
  {
    id: 'hamster_053',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_053_01',
  },
  {
    id: 'hamster_054',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_054_01',
  },
  {
    id: 'hamster_055',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_055_01',
  },
  {
    id: 'hamster_056',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_056_01',
  },
  {
    id: 'hamster_057',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_057_01',
  },
  {
    id: 'hamster_058',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_058_01',
  },
  {
    id: 'hamster_059',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_059_01',
  },
  {
    id: 'hamster_060',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_060_01',
  },
  {
    id: 'hamster_061',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_061_01',
  },
  {
    id: 'hamster_062',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_062_01',
  },
  {
    id: 'hamster_063',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'hamster_063_01',
  },
  {
    id: 'hamster_064',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'hamster_064_01',
  },
  {
    id: 'hamster_065',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'hamster_065_01',
  },
  {
    id: 'hamster_066',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'hamster_066_01',
  },
  {
    id: 'hamster_067',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'hamster_067_01',
  },
  {
    id: 'hamster_068',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'hamster_068_01',
  },
  {
    id: 'hamster_069',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'hamster_069_01',
  },
  {
    id: 'hamster_070',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'hamster_070_01',
  },
  {
    id: 'hamster_071',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'hamster_071_01',
  },
  {
    id: 'hamster_072',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'hamster_072_01',
  },
  {
    id: 'hamster_073',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'hamster_073_01',
  },
  {
    id: 'hamster_074',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'hamster_074_01',
  },
  {
    id: 'hamster_075',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'hamster_075_01',
  },
  {
    id: 'hamster_076',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'hamster_076_01',
  },
  {
    id: 'hamster_077',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'hamster_077_01',
  },
  {
    id: 'hamster_078',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'hamster_078_01',
  },
  {
    id: 'hamster_079',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'hamster_079_01',
  },
  {
    id: 'hamster_080',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'hamster_080_01',
  },
  {
    id: 'hamster_081',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'hamster_081_01',
  },
  {
    id: 'hamster_082',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'hamster_082_01',
  },
  {
    id: 'hamster_083',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'hamster_083_01',
  },
  {
    id: 'hamster_084',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'hamster_084_01',
  },
  {
    id: 'hamster_085',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'hamster_085_01',
  },
  {
    id: 'hamster_086',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'hamster_086_01',
  },
  {
    id: 'hamster_087',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['evolving'],
    script_id: 'hamster_087_01',
  },
  {
    id: 'hamster_088',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'hamster_088_01',
  },
  {
    id: 'hamster_089',
    pet_id: 'hamster',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'hamster_089_01',
  },
  {
    id: 'hamster_090',
    pet_id: 'hamster',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'hamster_090_01',
  },
  {
    id: 'hamster_091',
    pet_id: 'hamster',
    scenes: ['had_visitor'],
    script_id: 'hamster_091_01',
  },
  {
    id: 'hamster_092',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['fav_flower'],
    script_id: 'hamster_092_01',
  },
  {
    id: 'hamster_093',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['similar_yokai'],
    script_id: 'hamster_093_01',
  },
  {
    id: 'hamster_094',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['speciality'],
    script_id: 'hamster_094_01',
  },
  {
    id: 'hamster_095',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['fav_weather'],
    script_id: 'hamster_095_01',
  },
  {
    id: 'hamster_096',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['fav_bodypart'],
    script_id: 'hamster_096_01',
  },
  {
    id: 'hamster_097',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['happy_moment'],
    script_id: 'hamster_097_01',
  },
  {
    id: 'hamster_098',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['painful_moment'],
    script_id: 'hamster_098_01',
  },
  {
    id: 'hamster_099',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['maiden_name'],
    script_id: 'hamster_099_01',
  },
  {
    id: 'hamster_100',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['goto_country'],
    script_id: 'hamster_100_01',
  },
  {
    id: 'hamster_101',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['fav_story'],
    script_id: 'hamster_101_01',
  },
  {
    id: 'hamster_102',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['sunflower_or_morningglory'],
    script_id: 'hamster_102_01',
  },
  {
    id: 'hamster_103',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['friedshrimp'],
    script_id: 'hamster_103_01',
  },
  {
    id: 'hamster_104',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['wash_bathtowels'],
    script_id: 'hamster_104_01',
  },
  {
    id: 'hamster_105',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['zoo_or_aquarium'],
    script_id: 'hamster_105_01',
  },
  {
    id: 'hamster_106',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['marathon_or_100m'],
    script_id: 'hamster_106_01',
  },
  {
    id: 'hamster_107',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['mountain_or_ocean'],
    script_id: 'hamster_107_01',
  },
  {
    id: 'hamster_108',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['icecream_or_shavedice'],
    script_id: 'hamster_108_01',
  },
  {
    id: 'hamster_109',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['rice_or_bread'],
    script_id: 'hamster_109_01',
  },
  {
    id: 'hamster_110',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['ghost_exist'],
    script_id: 'hamster_110_01',
  },
  {
    id: 'hamster_111',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['hide_and_seek'],
    script_id: 'hamster_111_01',
  },
  {
    id: 'hamster_112',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['earlybird_nightowl'],
    script_id: 'hamster_112_01',
  },
  {
    id: 'hamster_113',
    pet_id: 'hamster',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['indoor_outdoor'],
    script_id: 'hamster_113_01',
  },
  {
    id: 'hamster_114',
    pet_id: 'hamster',
    scenes: ['initial_greetings'],
    script_id: 'hamster_114_01',
  },
  {
    id: 'hamster_115',
    pet_id: 'hamster',
    scenes: ['friend_greetings'],
    script_id: 'hamster_115_01',
  },
  {
    id: 'hamster_116',
    pet_id: 'hamster',
    scenes: ['friend_welcome'],
    script_id: 'hamster_116_01',
  },
  {
    id: 'hamster_117',
    pet_id: 'hamster',
    scenes: ['friend_appreciation'],
    script_id: 'hamster_117_01',
  },
  {
    id: 'hamster_118',
    pet_id: 'hamster',
    scenes: ['friend_goodby'],
    script_id: 'hamster_118_01',
  },
  {
    id: 'hamster_119',
    pet_id: 'hamster',
    scenes: ['friend_farewell'],
    script_id: 'hamster_119_01',
  },
  {
    id: 'hamster_120',
    pet_id: 'hamster',
    scenes: ['friend_kickedout'],
    script_id: 'hamster_120_01',
  },
  {
    id: 'hamster_121',
    pet_id: 'hamster',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'hamster_121_01',
  },
  {
    id: 'hamster_122',
    pet_id: 'hamster',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'hamster_122_01',
  },
  {
    id: 'hamster_123',
    pet_id: 'hamster',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'hamster_123_01',
  },
  {
    id: 'hamster_124',
    pet_id: 'hamster',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'hamster_124_01',
  },
  {
    id: 'hamster_125',
    pet_id: 'hamster',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'hamster_125_01',
  },
  {
    id: 'hamster_126',
    pet_id: 'hamster',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'hamster_126_01',
  },
  {
    id: 'hamster_127',
    pet_id: 'hamster',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'hamster_127_01',
  },
  {
    id: 'hamster_128',
    pet_id: 'hamster',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'hamster_128_01',
  },
  {
    id: 'hamster_129',
    pet_id: 'hamster',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'hamster_129_01',
  },
  {
    id: 'hamster_130',
    pet_id: 'hamster',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'hamster_130_01',
  },
  {
    id: 'turtle_001',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_001_01',
  },
  {
    id: 'turtle_002',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_002_01',
  },
  {
    id: 'turtle_003',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_003_01',
  },
  {
    id: 'turtle_004',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_004_01',
  },
  {
    id: 'turtle_005',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_005_01',
  },
  {
    id: 'turtle_006',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_006_01',
  },
  {
    id: 'turtle_007',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_007_01',
  },
  {
    id: 'turtle_008',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_008_01',
  },
  {
    id: 'turtle_009',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_009_01',
  },
  {
    id: 'turtle_010',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_010_01',
  },
  {
    id: 'turtle_011',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_011_01',
  },
  {
    id: 'turtle_012',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_012_01',
  },
  {
    id: 'turtle_013',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_013_01',
  },
  {
    id: 'turtle_014',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_014_01',
  },
  {
    id: 'turtle_015',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_015_01',
  },
  {
    id: 'turtle_016',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_016_01',
  },
  {
    id: 'turtle_017',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_017_01',
  },
  {
    id: 'turtle_018',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_018_01',
  },
  {
    id: 'turtle_019',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_019_01',
  },
  {
    id: 'turtle_020',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_020_01',
  },
  {
    id: 'turtle_021',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_021_01',
  },
  {
    id: 'turtle_022',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_022_01',
  },
  {
    id: 'turtle_023',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_023_01',
  },
  {
    id: 'turtle_024',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_024_01',
  },
  {
    id: 'turtle_025',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_025_01',
  },
  {
    id: 'turtle_026',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_026_01',
  },
  {
    id: 'turtle_027',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_027_01',
  },
  {
    id: 'turtle_028',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_028_01',
  },
  {
    id: 'turtle_029',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_029_01',
  },
  {
    id: 'turtle_030',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_030_01',
  },
  {
    id: 'turtle_031',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_031_01',
  },
  {
    id: 'turtle_032',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_032_01',
  },
  {
    id: 'turtle_033',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_033_01',
  },
  {
    id: 'turtle_034',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_034_01',
  },
  {
    id: 'turtle_035',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_035_01',
  },
  {
    id: 'turtle_036',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_036_01',
  },
  {
    id: 'turtle_037',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_037_01',
  },
  {
    id: 'turtle_038',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_038_01',
  },
  {
    id: 'turtle_039',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_039_01',
  },
  {
    id: 'turtle_040',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_040_01',
  },
  {
    id: 'turtle_041',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_041_01',
  },
  {
    id: 'turtle_042',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'turtle_042_01',
  },
  {
    id: 'turtle_043',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_043_01',
  },
  {
    id: 'turtle_044',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_044_01',
  },
  {
    id: 'turtle_045',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_045_01',
  },
  {
    id: 'turtle_046',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_046_01',
  },
  {
    id: 'turtle_047',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_047_01',
  },
  {
    id: 'turtle_048',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_048_01',
  },
  {
    id: 'turtle_049',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_049_01',
  },
  {
    id: 'turtle_050',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_050_01',
  },
  {
    id: 'turtle_051',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_051_01',
  },
  {
    id: 'turtle_052',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_052_01',
  },
  {
    id: 'turtle_053',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_053_01',
  },
  {
    id: 'turtle_054',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_054_01',
  },
  {
    id: 'turtle_055',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_055_01',
  },
  {
    id: 'turtle_056',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_056_01',
  },
  {
    id: 'turtle_057',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_057_01',
  },
  {
    id: 'turtle_058',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_058_01',
  },
  {
    id: 'turtle_059',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_059_01',
  },
  {
    id: 'turtle_060',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_060_01',
  },
  {
    id: 'turtle_061',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_061_01',
  },
  {
    id: 'turtle_062',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_062_01',
  },
  {
    id: 'turtle_063',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_063_01',
  },
  {
    id: 'turtle_064',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'turtle_064_01',
  },
  {
    id: 'turtle_065',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'turtle_065_01',
  },
  {
    id: 'turtle_066',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'turtle_066_01',
  },
  {
    id: 'turtle_067',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'turtle_067_01',
  },
  {
    id: 'turtle_068',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'turtle_068_01',
  },
  {
    id: 'turtle_069',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'turtle_069_01',
  },
  {
    id: 'turtle_070',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'turtle_070_01',
  },
  {
    id: 'turtle_071',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'turtle_071_01',
  },
  {
    id: 'turtle_072',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'turtle_072_01',
  },
  {
    id: 'turtle_073',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'turtle_073_01',
  },
  {
    id: 'turtle_074',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'turtle_074_01',
  },
  {
    id: 'turtle_075',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'turtle_075_01',
  },
  {
    id: 'turtle_076',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'turtle_076_01',
  },
  {
    id: 'turtle_077',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'turtle_077_01',
  },
  {
    id: 'turtle_078',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'turtle_078_01',
  },
  {
    id: 'turtle_079',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'turtle_079_01',
  },
  {
    id: 'turtle_080',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'turtle_080_01',
  },
  {
    id: 'turtle_081',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'turtle_081_01',
  },
  {
    id: 'turtle_082',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'turtle_082_01',
  },
  {
    id: 'turtle_083',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'turtle_083_01',
  },
  {
    id: 'turtle_084',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'turtle_084_01',
  },
  {
    id: 'turtle_085',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'turtle_085_01',
  },
  {
    id: 'turtle_086',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'turtle_086_01',
  },
  {
    id: 'turtle_087',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['evolving'],
    script_id: 'turtle_087_01',
  },
  {
    id: 'turtle_088',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'turtle_088_01',
  },
  {
    id: 'turtle_089',
    pet_id: 'turtle',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'turtle_089_01',
  },
  {
    id: 'turtle_090',
    pet_id: 'turtle',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'turtle_090_01',
  },
  {
    id: 'turtle_091',
    pet_id: 'turtle',
    scenes: ['had_visitor'],
    script_id: 'turtle_091_01',
  },
  {
    id: 'turtle_092',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['preferable_ramen'],
    script_id: 'turtle_092_01',
  },
  {
    id: 'turtle_093',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_sport'],
    script_id: 'turtle_093_01',
  },
  {
    id: 'turtle_094',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_manga'],
    script_id: 'turtle_094_01',
  },
  {
    id: 'turtle_095',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['holiday_life'],
    script_id: 'turtle_095_01',
  },
  {
    id: 'turtle_096',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_vehicle'],
    script_id: 'turtle_096_01',
  },
  {
    id: 'turtle_097',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_insect'],
    script_id: 'turtle_097_01',
  },
  {
    id: 'turtle_098',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['wash_body_part'],
    script_id: 'turtle_098_01',
  },
  {
    id: 'turtle_099',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['star_sign'],
    script_id: 'turtle_099_01',
  },
  {
    id: 'turtle_100',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['last_dinner'],
    script_id: 'turtle_100_01',
  },
  {
    id: 'turtle_101',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['where_to_live'],
    script_id: 'turtle_101_01',
  },
  {
    id: 'turtle_102',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['riceball_type'],
    script_id: 'turtle_102_01',
  },
  {
    id: 'turtle_103',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['mush_bamboo'],
    script_id: 'turtle_103_01',
  },
  {
    id: 'turtle_104',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['soba_udon'],
    script_id: 'turtle_104_01',
  },
  {
    id: 'turtle_105',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['like_natto'],
    script_id: 'turtle_105_01',
  },
  {
    id: 'turtle_106',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    script_id: 'turtle_106_01',
  },
  {
    id: 'turtle_107',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['end_roll'],
    script_id: 'turtle_107_01',
  },
  {
    id: 'turtle_108',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['older_younger'],
    script_id: 'turtle_108_01',
  },
  {
    id: 'turtle_109',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['city_country'],
    script_id: 'turtle_109_01',
  },
  {
    id: 'turtle_110',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['tp_single_double'],
    script_id: 'turtle_110_01',
  },
  {
    id: 'turtle_111',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['okonomi_cut'],
    script_id: 'turtle_111_01',
  },
  {
    id: 'turtle_112',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['goku_luffy'],
    script_id: 'turtle_112_01',
  },
  {
    id: 'turtle_113',
    pet_id: 'turtle',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['boke_tsukkomi'],
    script_id: 'turtle_113_01',
  },
  {
    id: 'turtle_114',
    pet_id: 'turtle',
    scenes: ['initial_greetings'],
    script_id: 'turtle_114_01',
  },
  {
    id: 'turtle_115',
    pet_id: 'turtle',
    scenes: ['friend_greetings'],
    script_id: 'turtle_115_01',
  },
  {
    id: 'turtle_116',
    pet_id: 'turtle',
    scenes: ['friend_welcome'],
    script_id: 'turtle_116_01',
  },
  {
    id: 'turtle_117',
    pet_id: 'turtle',
    scenes: ['friend_appreciation'],
    script_id: 'turtle_117_01',
  },
  {
    id: 'turtle_118',
    pet_id: 'turtle',
    scenes: ['friend_goodby'],
    script_id: 'turtle_118_01',
  },
  {
    id: 'turtle_119',
    pet_id: 'turtle',
    scenes: ['friend_farewell'],
    script_id: 'turtle_119_01',
  },
  {
    id: 'turtle_120',
    pet_id: 'turtle',
    scenes: ['friend_kickedout'],
    script_id: 'turtle_120_01',
  },
  {
    id: 'turtle_121',
    pet_id: 'turtle',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'turtle_121_01',
  },
  {
    id: 'turtle_122',
    pet_id: 'turtle',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'turtle_122_01',
  },
  {
    id: 'turtle_123',
    pet_id: 'turtle',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'turtle_123_01',
  },
  {
    id: 'turtle_124',
    pet_id: 'turtle',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'turtle_124_01',
  },
  {
    id: 'turtle_125',
    pet_id: 'turtle',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'turtle_125_01',
  },
  {
    id: 'turtle_126',
    pet_id: 'turtle',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'turtle_126_01',
  },
  {
    id: 'turtle_127',
    pet_id: 'turtle',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'turtle_127_01',
  },
  {
    id: 'turtle_128',
    pet_id: 'turtle',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'turtle_128_01',
  },
  {
    id: 'turtle_129',
    pet_id: 'turtle',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'turtle_129_01',
  },
  {
    id: 'turtle_130',
    pet_id: 'turtle',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'turtle_130_01',
  },
  {
    id: 'seaotter_001',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_001_01',
  },
  {
    id: 'seaotter_002',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_002_01',
  },
  {
    id: 'seaotter_003',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_003_01',
  },
  {
    id: 'seaotter_004',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_004_01',
  },
  {
    id: 'seaotter_005',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_005_01',
  },
  {
    id: 'seaotter_006',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_006_01',
  },
  {
    id: 'seaotter_007',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_007_01',
  },
  {
    id: 'seaotter_008',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_008_01',
  },
  {
    id: 'seaotter_009',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_009_01',
  },
  {
    id: 'seaotter_010',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_010_01',
  },
  {
    id: 'seaotter_011',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_011_01',
  },
  {
    id: 'seaotter_012',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_012_01',
  },
  {
    id: 'seaotter_013',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_013_01',
  },
  {
    id: 'seaotter_014',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_014_01',
  },
  {
    id: 'seaotter_015',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_015_01',
  },
  {
    id: 'seaotter_016',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_016_01',
  },
  {
    id: 'seaotter_017',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_017_01',
  },
  {
    id: 'seaotter_018',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_018_01',
  },
  {
    id: 'seaotter_019',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_019_01',
  },
  {
    id: 'seaotter_020',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_020_01',
  },
  {
    id: 'seaotter_021',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_021_01',
  },
  {
    id: 'seaotter_022',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_022_01',
  },
  {
    id: 'seaotter_023',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_023_01',
  },
  {
    id: 'seaotter_024',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_024_01',
  },
  {
    id: 'seaotter_025',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_025_01',
  },
  {
    id: 'seaotter_026',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_026_01',
  },
  {
    id: 'seaotter_027',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_027_01',
  },
  {
    id: 'seaotter_028',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_028_01',
  },
  {
    id: 'seaotter_029',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_029_01',
  },
  {
    id: 'seaotter_030',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_030_01',
  },
  {
    id: 'seaotter_031',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_031_01',
  },
  {
    id: 'seaotter_032',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_032_01',
  },
  {
    id: 'seaotter_033',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_033_01',
  },
  {
    id: 'seaotter_034',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_034_01',
  },
  {
    id: 'seaotter_035',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_035_01',
  },
  {
    id: 'seaotter_036',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_036_01',
  },
  {
    id: 'seaotter_037',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_037_01',
  },
  {
    id: 'seaotter_038',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_038_01',
  },
  {
    id: 'seaotter_039',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_039_01',
  },
  {
    id: 'seaotter_040',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_040_01',
  },
  {
    id: 'seaotter_041',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_041_01',
  },
  {
    id: 'seaotter_042',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'seaotter_042_01',
  },
  {
    id: 'seaotter_043',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_043_01',
  },
  {
    id: 'seaotter_044',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_044_01',
  },
  {
    id: 'seaotter_045',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_045_01',
  },
  {
    id: 'seaotter_046',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_046_01',
  },
  {
    id: 'seaotter_047',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_047_01',
  },
  {
    id: 'seaotter_048',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_048_01',
  },
  {
    id: 'seaotter_049',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_049_01',
  },
  {
    id: 'seaotter_050',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_050_01',
  },
  {
    id: 'seaotter_051',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_051_01',
  },
  {
    id: 'seaotter_052',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_052_01',
  },
  {
    id: 'seaotter_053',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_053_01',
  },
  {
    id: 'seaotter_054',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_054_01',
  },
  {
    id: 'seaotter_055',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_055_01',
  },
  {
    id: 'seaotter_056',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_056_01',
  },
  {
    id: 'seaotter_057',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_057_01',
  },
  {
    id: 'seaotter_058',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_058_01',
  },
  {
    id: 'seaotter_059',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_059_01',
  },
  {
    id: 'seaotter_060',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_060_01',
  },
  {
    id: 'seaotter_061',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_061_01',
  },
  {
    id: 'seaotter_062',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_062_01',
  },
  {
    id: 'seaotter_063',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'seaotter_063_01',
  },
  {
    id: 'seaotter_064',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'seaotter_064_01',
  },
  {
    id: 'seaotter_065',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'seaotter_065_01',
  },
  {
    id: 'seaotter_066',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'seaotter_066_01',
  },
  {
    id: 'seaotter_067',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'seaotter_067_01',
  },
  {
    id: 'seaotter_068',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'seaotter_068_01',
  },
  {
    id: 'seaotter_069',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'seaotter_069_01',
  },
  {
    id: 'seaotter_070',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'seaotter_070_01',
  },
  {
    id: 'seaotter_071',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'seaotter_071_01',
  },
  {
    id: 'seaotter_072',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'seaotter_072_01',
  },
  {
    id: 'seaotter_073',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'seaotter_073_01',
  },
  {
    id: 'seaotter_074',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'seaotter_074_01',
  },
  {
    id: 'seaotter_075',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'seaotter_075_01',
  },
  {
    id: 'seaotter_076',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'seaotter_076_01',
  },
  {
    id: 'seaotter_077',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'seaotter_077_01',
  },
  {
    id: 'seaotter_078',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'seaotter_078_01',
  },
  {
    id: 'seaotter_079',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'seaotter_079_01',
  },
  {
    id: 'seaotter_080',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'seaotter_080_01',
  },
  {
    id: 'seaotter_081',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'seaotter_081_01',
  },
  {
    id: 'seaotter_082',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'seaotter_082_01',
  },
  {
    id: 'seaotter_083',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'seaotter_083_01',
  },
  {
    id: 'seaotter_084',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'seaotter_084_01',
  },
  {
    id: 'seaotter_085',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'seaotter_085_01',
  },
  {
    id: 'seaotter_086',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'seaotter_086_01',
  },
  {
    id: 'seaotter_087',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['evolving'],
    script_id: 'seaotter_087_01',
  },
  {
    id: 'seaotter_088',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'seaotter_088_01',
  },
  {
    id: 'seaotter_089',
    pet_id: 'seaotter',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'seaotter_089_01',
  },
  {
    id: 'seaotter_090',
    pet_id: 'seaotter',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'seaotter_090_01',
  },
  {
    id: 'seaotter_091',
    pet_id: 'seaotter',
    scenes: ['had_visitor'],
    script_id: 'seaotter_091_01',
  },
  {
    id: 'seaotter_092',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_brand'],
    script_id: 'seaotter_092_01',
  },
  {
    id: 'seaotter_093',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_color'],
    script_id: 'seaotter_093_01',
  },
  {
    id: 'seaotter_094',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_snack'],
    script_id: 'seaotter_094_01',
  },
  {
    id: 'seaotter_095',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_gem'],
    script_id: 'seaotter_095_01',
  },
  {
    id: 'seaotter_096',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['childhood_dream'],
    script_id: 'seaotter_096_01',
  },
  {
    id: 'seaotter_097',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['my_boom'],
    script_id: 'seaotter_097_01',
  },
  {
    id: 'seaotter_098',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['peculiarity'],
    script_id: 'seaotter_098_01',
  },
  {
    id: 'seaotter_099',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['disliked_food'],
    script_id: 'seaotter_099_01',
  },
  {
    id: 'seaotter_100',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_swim'],
    script_id: 'seaotter_100_01',
  },
  {
    id: 'seaotter_101',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_shell'],
    script_id: 'seaotter_101_01',
  },
  {
    id: 'seaotter_102',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['eat_first_later'],
    script_id: 'seaotter_102_01',
  },
  {
    id: 'seaotter_103',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['cram_like'],
    script_id: 'seaotter_103_01',
  },
  {
    id: 'seaotter_104',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['hasty_slow'],
    script_id: 'seaotter_104_01',
  },
  {
    id: 'seaotter_105',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['coffee_like'],
    script_id: 'seaotter_105_01',
  },
  {
    id: 'seaotter_106',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['movie_music'],
    script_id: 'seaotter_106_01',
  },
  {
    id: 'seaotter_107',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['stripe_border'],
    script_id: 'seaotter_107_01',
  },
  {
    id: 'seaotter_108',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['tomato_cream'],
    script_id: 'seaotter_108_01',
  },
  {
    id: 'seaotter_109',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['koala_seaotter'],
    script_id: 'seaotter_109_01',
  },
  {
    id: 'seaotter_110',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['tea_type'],
    script_id: 'seaotter_110_01',
  },
  {
    id: 'seaotter_111',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['fried_shrimp'],
    script_id: 'seaotter_111_01',
  },
  {
    id: 'seaotter_112',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['cold_noodles'],
    script_id: 'seaotter_112_01',
  },
  {
    id: 'seaotter_113',
    pet_id: 'seaotter',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['hokkaido_okinawa'],
    script_id: 'seaotter_113_01',
  },
  {
    id: 'seaotter_114',
    pet_id: 'seaotter',
    scenes: ['initial_greetings'],
    script_id: 'seaotter_114_01',
  },
  {
    id: 'seaotter_115',
    pet_id: 'seaotter',
    scenes: ['friend_greetings'],
    script_id: 'seaotter_115_01',
  },
  {
    id: 'seaotter_116',
    pet_id: 'seaotter',
    scenes: ['friend_welcome'],
    script_id: 'seaotter_116_01',
  },
  {
    id: 'seaotter_117',
    pet_id: 'seaotter',
    scenes: ['friend_appreciation'],
    script_id: 'seaotter_117_01',
  },
  {
    id: 'seaotter_118',
    pet_id: 'seaotter',
    scenes: ['friend_goodby'],
    script_id: 'seaotter_118_01',
  },
  {
    id: 'seaotter_119',
    pet_id: 'seaotter',
    scenes: ['friend_farewell'],
    script_id: 'seaotter_119_01',
  },
  {
    id: 'seaotter_120',
    pet_id: 'seaotter',
    scenes: ['friend_kickedout'],
    script_id: 'seaotter_120_01',
  },
  {
    id: 'seaotter_121',
    pet_id: 'seaotter',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'seaotter_121_01',
  },
  {
    id: 'seaotter_122',
    pet_id: 'seaotter',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'seaotter_122_01',
  },
  {
    id: 'seaotter_123',
    pet_id: 'seaotter',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'seaotter_123_01',
  },
  {
    id: 'seaotter_124',
    pet_id: 'seaotter',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'seaotter_124_01',
  },
  {
    id: 'seaotter_125',
    pet_id: 'seaotter',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'seaotter_125_01',
  },
  {
    id: 'seaotter_126',
    pet_id: 'seaotter',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'seaotter_126_01',
  },
  {
    id: 'seaotter_127',
    pet_id: 'seaotter',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'seaotter_127_01',
  },
  {
    id: 'seaotter_128',
    pet_id: 'seaotter',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'seaotter_128_01',
  },
  {
    id: 'seaotter_129',
    pet_id: 'seaotter',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'seaotter_129_01',
  },
  {
    id: 'seaotter_130',
    pet_id: 'seaotter',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'seaotter_130_01',
  },
  {
    id: 'cat_001',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_001_01',
  },
  {
    id: 'cat_002',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_002_01',
  },
  {
    id: 'cat_003',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_003_01',
  },
  {
    id: 'cat_004',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_004_01',
  },
  {
    id: 'cat_005',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_005_01',
  },
  {
    id: 'cat_006',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_006_01',
  },
  {
    id: 'cat_007',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_007_01',
  },
  {
    id: 'cat_008',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_008_01',
  },
  {
    id: 'cat_009',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_009_01',
  },
  {
    id: 'cat_010',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_010_01',
  },
  {
    id: 'cat_011',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_011_01',
  },
  {
    id: 'cat_012',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_012_01',
  },
  {
    id: 'cat_013',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_013_01',
  },
  {
    id: 'cat_014',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_014_01',
  },
  {
    id: 'cat_015',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_015_01',
  },
  {
    id: 'cat_016',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_016_01',
  },
  {
    id: 'cat_017',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_017_01',
  },
  {
    id: 'cat_018',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_018_01',
  },
  {
    id: 'cat_019',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_019_01',
  },
  {
    id: 'cat_020',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_020_01',
  },
  {
    id: 'cat_021',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_021_01',
  },
  {
    id: 'cat_022',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_022_01',
  },
  {
    id: 'cat_023',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_023_01',
  },
  {
    id: 'cat_024',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_024_01',
  },
  {
    id: 'cat_025',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_025_01',
  },
  {
    id: 'cat_026',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_026_01',
  },
  {
    id: 'cat_027',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_027_01',
  },
  {
    id: 'cat_028',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_028_01',
  },
  {
    id: 'cat_029',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_029_01',
  },
  {
    id: 'cat_030',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_030_01',
  },
  {
    id: 'cat_031',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_031_01',
  },
  {
    id: 'cat_032',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_032_01',
  },
  {
    id: 'cat_033',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_033_01',
  },
  {
    id: 'cat_034',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_034_01',
  },
  {
    id: 'cat_035',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_035_01',
  },
  {
    id: 'cat_036',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_036_01',
  },
  {
    id: 'cat_037',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_037_01',
  },
  {
    id: 'cat_038',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_038_01',
  },
  {
    id: 'cat_039',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_039_01',
  },
  {
    id: 'cat_040',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_040_01',
  },
  {
    id: 'cat_041',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_041_01',
  },
  {
    id: 'cat_042',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'cat_042_01',
  },
  {
    id: 'cat_043',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_043_01',
  },
  {
    id: 'cat_044',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_044_01',
  },
  {
    id: 'cat_045',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_045_01',
  },
  {
    id: 'cat_046',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_046_01',
  },
  {
    id: 'cat_047',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_047_01',
  },
  {
    id: 'cat_048',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_048_01',
  },
  {
    id: 'cat_049',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_049_01',
  },
  {
    id: 'cat_050',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_050_01',
  },
  {
    id: 'cat_051',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_051_01',
  },
  {
    id: 'cat_052',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_052_01',
  },
  {
    id: 'cat_053',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_053_01',
  },
  {
    id: 'cat_054',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_054_01',
  },
  {
    id: 'cat_055',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_055_01',
  },
  {
    id: 'cat_056',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_056_01',
  },
  {
    id: 'cat_057',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_057_01',
  },
  {
    id: 'cat_058',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_058_01',
  },
  {
    id: 'cat_059',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_059_01',
  },
  {
    id: 'cat_060',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_060_01',
  },
  {
    id: 'cat_061',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_061_01',
  },
  {
    id: 'cat_062',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_062_01',
  },
  {
    id: 'cat_063',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'cat_063_01',
  },
  {
    id: 'cat_064',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'cat_064_01',
  },
  {
    id: 'cat_065',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'cat_065_01',
  },
  {
    id: 'cat_066',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'cat_066_01',
  },
  {
    id: 'cat_067',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'cat_067_01',
  },
  {
    id: 'cat_068',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'cat_068_01',
  },
  {
    id: 'cat_069',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'cat_069_01',
  },
  {
    id: 'cat_070',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'cat_070_01',
  },
  {
    id: 'cat_071',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'cat_071_01',
  },
  {
    id: 'cat_072',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'cat_072_01',
  },
  {
    id: 'cat_073',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'cat_073_01',
  },
  {
    id: 'cat_074',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'cat_074_01',
  },
  {
    id: 'cat_075',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'cat_075_01',
  },
  {
    id: 'cat_076',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'cat_076_01',
  },
  {
    id: 'cat_077',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'cat_077_01',
  },
  {
    id: 'cat_078',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'cat_078_01',
  },
  {
    id: 'cat_079',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'cat_079_01',
  },
  {
    id: 'cat_080',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'cat_080_01',
  },
  {
    id: 'cat_081',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'cat_081_01',
  },
  {
    id: 'cat_082',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'cat_082_01',
  },
  {
    id: 'cat_083',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'cat_083_01',
  },
  {
    id: 'cat_084',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'cat_084_01',
  },
  {
    id: 'cat_085',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'cat_085_01',
  },
  {
    id: 'cat_086',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'cat_086_01',
  },
  {
    id: 'cat_087',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['evolving'],
    script_id: 'cat_087_01',
  },
  {
    id: 'cat_088',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'cat_088_01',
  },
  {
    id: 'cat_089',
    pet_id: 'cat',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'cat_089_01',
  },
  {
    id: 'cat_090',
    pet_id: 'cat',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'cat_090_01',
  },
  {
    id: 'cat_091',
    pet_id: 'cat',
    scenes: ['had_visitor'],
    script_id: 'cat_091_01',
  },
  {
    id: 'cat_092',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['sports_not_good_at'],
    script_id: 'cat_092_01',
  },
  {
    id: 'cat_093',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['miso_soup'],
    script_id: 'cat_093_01',
  },
  {
    id: 'cat_094',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['holiday_todo'],
    script_id: 'cat_094_01',
  },
  {
    id: 'cat_095',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_subject'],
    script_id: 'cat_095_01',
  },
  {
    id: 'cat_096',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_card_game'],
    script_id: 'cat_096_01',
  },
  {
    id: 'cat_097',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['piano_song'],
    script_id: 'cat_097_01',
  },
  {
    id: 'cat_098',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_tv_show'],
    script_id: 'cat_098_01',
  },
  {
    id: 'cat_099',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['hair_style'],
    script_id: 'cat_099_01',
  },
  {
    id: 'cat_100',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['bento_side_dish'],
    script_id: 'cat_100_01',
  },
  {
    id: 'cat_101',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['conveni_buy'],
    script_id: 'cat_101_01',
  },
  {
    id: 'cat_102',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['meat_fish'],
    script_id: 'cat_102_01',
  },
  {
    id: 'cat_103',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['bed_futon'],
    script_id: 'cat_103_01',
  },
  {
    id: 'cat_104',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['ac_fan'],
    script_id: 'cat_104_01',
  },
  {
    id: 'cat_105',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['melon_watermelon'],
    script_id: 'cat_105_01',
  },
  {
    id: 'cat_106',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['hammock_waterbed'],
    script_id: 'cat_106_01',
  },
  {
    id: 'cat_107',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['ferris_coaster'],
    script_id: 'cat_107_01',
  },
  {
    id: 'cat_108',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['oyako_don'],
    script_id: 'cat_108_01',
  },
  {
    id: 'cat_109',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['body_flexibility'],
    script_id: 'cat_109_01',
  },
  {
    id: 'cat_110',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['love_someone'],
    script_id: 'cat_110_01',
  },
  {
    id: 'cat_111',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['spicy_foods'],
    script_id: 'cat_111_01',
  },
  {
    id: 'cat_112',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['buy_lottery'],
    script_id: 'cat_112_01',
  },
  {
    id: 'cat_113',
    pet_id: 'cat',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['subtitle_dub'],
    script_id: 'cat_113_01',
  },
  {
    id: 'cat_114',
    pet_id: 'cat',
    scenes: ['initial_greetings'],
    script_id: 'cat_114_01',
  },
  {
    id: 'cat_115',
    pet_id: 'cat',
    scenes: ['friend_greetings'],
    script_id: 'cat_115_01',
  },
  {
    id: 'cat_116',
    pet_id: 'cat',
    scenes: ['friend_welcome'],
    script_id: 'cat_116_01',
  },
  {
    id: 'cat_117',
    pet_id: 'cat',
    scenes: ['friend_appreciation'],
    script_id: 'cat_117_01',
  },
  {
    id: 'cat_118',
    pet_id: 'cat',
    scenes: ['friend_goodby'],
    script_id: 'cat_118_01',
  },
  {
    id: 'cat_119',
    pet_id: 'cat',
    scenes: ['friend_farewell'],
    script_id: 'cat_119_01',
  },
  {
    id: 'cat_120',
    pet_id: 'cat',
    scenes: ['friend_kickedout'],
    script_id: 'cat_120_01',
  },
  {
    id: 'cat_121',
    pet_id: 'cat',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'cat_121_01',
  },
  {
    id: 'cat_122',
    pet_id: 'cat',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'cat_122_01',
  },
  {
    id: 'cat_123',
    pet_id: 'cat',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'cat_123_01',
  },
  {
    id: 'cat_124',
    pet_id: 'cat',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'cat_124_01',
  },
  {
    id: 'cat_125',
    pet_id: 'cat',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'cat_125_01',
  },
  {
    id: 'cat_126',
    pet_id: 'cat',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'cat_126_01',
  },
  {
    id: 'cat_127',
    pet_id: 'cat',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'cat_127_01',
  },
  {
    id: 'cat_128',
    pet_id: 'cat',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'cat_128_01',
  },
  {
    id: 'cat_129',
    pet_id: 'cat',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'cat_129_01',
  },
  {
    id: 'cat_130',
    pet_id: 'cat',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'cat_130_01',
  },
  {
    id: 'whale_001',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_001_01',
  },
  {
    id: 'whale_002',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_002_01',
  },
  {
    id: 'whale_003',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_003_01',
  },
  {
    id: 'whale_004',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_004_01',
  },
  {
    id: 'whale_005',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_005_01',
  },
  {
    id: 'whale_006',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_006_01',
  },
  {
    id: 'whale_007',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_007_01',
  },
  {
    id: 'whale_008',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_008_01',
  },
  {
    id: 'whale_009',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_009_01',
  },
  {
    id: 'whale_010',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_010_01',
  },
  {
    id: 'whale_011',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_011_01',
  },
  {
    id: 'whale_012',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_012_01',
  },
  {
    id: 'whale_013',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_013_01',
  },
  {
    id: 'whale_014',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_014_01',
  },
  {
    id: 'whale_015',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_015_01',
  },
  {
    id: 'whale_016',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_016_01',
  },
  {
    id: 'whale_017',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_017_01',
  },
  {
    id: 'whale_018',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_018_01',
  },
  {
    id: 'whale_019',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_019_01',
  },
  {
    id: 'whale_020',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_020_01',
  },
  {
    id: 'whale_021',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_021_01',
  },
  {
    id: 'whale_022',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_022_01',
  },
  {
    id: 'whale_023',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_023_01',
  },
  {
    id: 'whale_024',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_024_01',
  },
  {
    id: 'whale_025',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_025_01',
  },
  {
    id: 'whale_026',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_026_01',
  },
  {
    id: 'whale_027',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_027_01',
  },
  {
    id: 'whale_028',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_028_01',
  },
  {
    id: 'whale_029',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_029_01',
  },
  {
    id: 'whale_030',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_030_01',
  },
  {
    id: 'whale_031',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_031_01',
  },
  {
    id: 'whale_032',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_032_01',
  },
  {
    id: 'whale_033',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_033_01',
  },
  {
    id: 'whale_034',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_034_01',
  },
  {
    id: 'whale_035',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_035_01',
  },
  {
    id: 'whale_036',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_036_01',
  },
  {
    id: 'whale_037',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_037_01',
  },
  {
    id: 'whale_038',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_038_01',
  },
  {
    id: 'whale_039',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_039_01',
  },
  {
    id: 'whale_040',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_040_01',
  },
  {
    id: 'whale_041',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_041_01',
  },
  {
    id: 'whale_042',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'whale_042_01',
  },
  {
    id: 'whale_043',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_043_01',
  },
  {
    id: 'whale_044',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_044_01',
  },
  {
    id: 'whale_045',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_045_01',
  },
  {
    id: 'whale_046',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_046_01',
  },
  {
    id: 'whale_047',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_047_01',
  },
  {
    id: 'whale_048',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_048_01',
  },
  {
    id: 'whale_049',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_049_01',
  },
  {
    id: 'whale_050',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_050_01',
  },
  {
    id: 'whale_051',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_051_01',
  },
  {
    id: 'whale_052',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_052_01',
  },
  {
    id: 'whale_053',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_053_01',
  },
  {
    id: 'whale_054',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_054_01',
  },
  {
    id: 'whale_055',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_055_01',
  },
  {
    id: 'whale_056',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_056_01',
  },
  {
    id: 'whale_057',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_057_01',
  },
  {
    id: 'whale_058',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_058_01',
  },
  {
    id: 'whale_059',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_059_01',
  },
  {
    id: 'whale_060',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_060_01',
  },
  {
    id: 'whale_061',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_061_01',
  },
  {
    id: 'whale_062',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_062_01',
  },
  {
    id: 'whale_063',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'whale_063_01',
  },
  {
    id: 'whale_064',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'whale_064_01',
  },
  {
    id: 'whale_065',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'whale_065_01',
  },
  {
    id: 'whale_066',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'whale_066_01',
  },
  {
    id: 'whale_067',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'whale_067_01',
  },
  {
    id: 'whale_068',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'whale_068_01',
  },
  {
    id: 'whale_069',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'whale_069_01',
  },
  {
    id: 'whale_070',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'whale_070_01',
  },
  {
    id: 'whale_071',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'whale_071_01',
  },
  {
    id: 'whale_072',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'whale_072_01',
  },
  {
    id: 'whale_073',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'whale_073_01',
  },
  {
    id: 'whale_074',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'whale_074_01',
  },
  {
    id: 'whale_075',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'whale_075_01',
  },
  {
    id: 'whale_076',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'whale_076_01',
  },
  {
    id: 'whale_077',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'whale_077_01',
  },
  {
    id: 'whale_078',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'whale_078_01',
  },
  {
    id: 'whale_079',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'whale_079_01',
  },
  {
    id: 'whale_080',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'whale_080_01',
  },
  {
    id: 'whale_081',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'whale_081_01',
  },
  {
    id: 'whale_082',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'whale_082_01',
  },
  {
    id: 'whale_083',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'whale_083_01',
  },
  {
    id: 'whale_084',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'whale_084_01',
  },
  {
    id: 'whale_085',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'whale_085_01',
  },
  {
    id: 'whale_086',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'whale_086_01',
  },
  {
    id: 'whale_087',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'whale_087_01',
  },
  {
    id: 'whale_088',
    pet_id: 'whale',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'whale_088_01',
  },
  {
    id: 'whale_089',
    pet_id: 'whale',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'whale_089_01',
  },
  {
    id: 'whale_090',
    pet_id: 'whale',
    scenes: ['had_visitor'],
    script_id: 'whale_090_01',
  },
  {
    id: 'whale_091',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['shout_to_sea'],
    script_id: 'whale_091_01',
  },
  {
    id: 'whale_092',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['must_have_beach'],
    script_id: 'whale_092_01',
  },
  {
    id: 'whale_093',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['man_woman_reason'],
    script_id: 'whale_093_01',
  },
  {
    id: 'whale_094',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['shcool_regulations'],
    script_id: 'whale_094_01',
  },
  {
    id: 'whale_095',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['bring_to_island'],
    script_id: 'whale_095_01',
  },
  {
    id: 'whale_096',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['want_most'],
    script_id: 'whale_096_01',
  },
  {
    id: 'whale_097',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['future_dream'],
    script_id: 'whale_097_01',
  },
  {
    id: 'whale_098',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['habit_before_sleep'],
    script_id: 'whale_098_01',
  },
  {
    id: 'whale_099',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['grownup'],
    script_id: 'whale_099_01',
  },
  {
    id: 'whale_100',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['slander'],
    script_id: 'whale_100_01',
  },
  {
    id: 'whale_101',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['good_at_cooking'],
    script_id: 'whale_101_01',
  },
  {
    id: 'whale_102',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['todo_in_ocean'],
    script_id: 'whale_102_01',
  },
  {
    id: 'whale_103',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['friendship_with_opposite_sex'],
    script_id: 'whale_103_01',
  },
  {
    id: 'whale_104',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['xyz'],
    script_id: 'whale_104_01',
  },
  {
    id: 'whale_105',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['angry_memory'],
    script_id: 'whale_105_01',
  },
  {
    id: 'whale_106',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['review'],
    script_id: 'whale_106_01',
  },
  {
    id: 'whale_107',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['japan_oversea'],
    script_id: 'whale_107_01',
  },
  {
    id: 'whale_108',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['food_beach'],
    script_id: 'whale_108_01',
  },
  {
    id: 'whale_109',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['last_first'],
    script_id: 'whale_109_01',
  },
  {
    id: 'whale_110',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['first_meeting'],
    script_id: 'whale_110_01',
  },
  {
    id: 'whale_111',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['self_confidence'],
    script_id: 'whale_111_01',
  },
  {
    id: 'whale_112',
    pet_id: 'whale',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['sm'],
    script_id: 'whale_112_01',
  },
  {
    id: 'whale_113',
    pet_id: 'whale',
    scenes: ['initial_greetings'],
    script_id: 'whale_113_01',
  },
  {
    id: 'whale_114',
    pet_id: 'whale',
    scenes: ['friend_greetings'],
    script_id: 'whale_114_01',
  },
  {
    id: 'whale_115',
    pet_id: 'whale',
    scenes: ['friend_welcome'],
    script_id: 'whale_115_01',
  },
  {
    id: 'whale_116',
    pet_id: 'whale',
    scenes: ['friend_appreciation'],
    script_id: 'whale_116_01',
  },
  {
    id: 'whale_117',
    pet_id: 'whale',
    scenes: ['friend_goodby'],
    script_id: 'whale_117_01',
  },
  {
    id: 'whale_118',
    pet_id: 'whale',
    scenes: ['friend_farewell'],
    script_id: 'whale_118_01',
  },
  {
    id: 'whale_119',
    pet_id: 'whale',
    scenes: ['friend_kickedout'],
    script_id: 'whale_119_01',
  },
  {
    id: 'whale_120',
    pet_id: 'whale',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'whale_120_01',
  },
  {
    id: 'whale_121',
    pet_id: 'whale',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'whale_121_01',
  },
  {
    id: 'whale_122',
    pet_id: 'whale',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'whale_122_01',
  },
  {
    id: 'whale_123',
    pet_id: 'whale',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'whale_123_01',
  },
  {
    id: 'whale_124',
    pet_id: 'whale',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'whale_124_01',
  },
  {
    id: 'whale_125',
    pet_id: 'whale',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'whale_125_01',
  },
  {
    id: 'whale_126',
    pet_id: 'whale',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'whale_126_01',
  },
  {
    id: 'whale_127',
    pet_id: 'whale',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'whale_127_01',
  },
  {
    id: 'whale_128',
    pet_id: 'whale',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'whale_128_01',
  },
  {
    id: 'whale_129',
    pet_id: 'whale',
    scenes: ['not_cured'],
    script_id: 'whale_129_01',
  },
  {
    id: 'whale_130',
    pet_id: 'whale',
    scenes: ['duo_inviter_invite'],
    script_id: 'whale_130_01',
  },
  {
    id: 'whale_131',
    pet_id: 'whale',
    scenes: ['duo_invitee_invited'],
    script_id: 'whale_131_01',
  },
  {
    id: 'whale_132',
    pet_id: 'whale',
    scenes: ['duo_inviter_home'],
    script_id: 'whale_132_01',
  },
  {
    id: 'whale_133',
    pet_id: 'whale',
    scenes: ['duo_invitee_home'],
    script_id: 'whale_133_01',
  },
  {
    id: 'whale_134',
    pet_id: 'whale',
    scenes: ['duo_inviter_notified'],
    script_id: 'whale_134_01',
  },
  {
    id: 'whale_135',
    pet_id: 'whale',
    scenes: ['duo_invitee_answer'],
    script_id: 'whale_135_01',
  },
  {
    id: 'whale_136',
    pet_id: 'whale',
    scenes: ['duo_invitee_accept'],
    script_id: 'whale_136_01',
  },
  {
    id: 'whale_137',
    pet_id: 'whale',
    scenes: ['duo_invitee_refuse'],
    script_id: 'whale_137_01',
  },
  {
    id: 'whale_138',
    pet_id: 'whale',
    scenes: ['duo_invitee_message_intro'],
    script_id: 'whale_138_01',
  },
  {
    id: 'whale_139',
    pet_id: 'whale',
    scenes: ['duo_invitee_message'],
    script_id: 'whale_139_01',
  },
  {
    id: 'whale_140',
    pet_id: 'whale',
    scenes: ['duo_inviter_refused'],
    script_id: 'whale_140_01',
  },
  {
    id: 'giraffe_001',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_001_01',
  },
  {
    id: 'giraffe_002',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_002_01',
  },
  {
    id: 'giraffe_003',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_003_01',
  },
  {
    id: 'giraffe_004',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_004_01',
  },
  {
    id: 'giraffe_005',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_005_01',
  },
  {
    id: 'giraffe_006',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_006_01',
  },
  {
    id: 'giraffe_007',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_007_01',
  },
  {
    id: 'giraffe_008',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_008_01',
  },
  {
    id: 'giraffe_009',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_009_01',
  },
  {
    id: 'giraffe_010',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_010_01',
  },
  {
    id: 'giraffe_011',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_011_01',
  },
  {
    id: 'giraffe_012',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_012_01',
  },
  {
    id: 'giraffe_013',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_013_01',
  },
  {
    id: 'giraffe_014',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_014_01',
  },
  {
    id: 'giraffe_015',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_015_01',
  },
  {
    id: 'giraffe_016',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_016_01',
  },
  {
    id: 'giraffe_017',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_017_01',
  },
  {
    id: 'giraffe_018',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_018_01',
  },
  {
    id: 'giraffe_019',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_019_01',
  },
  {
    id: 'giraffe_020',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_020_01',
  },
  {
    id: 'giraffe_021',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_021_01',
  },
  {
    id: 'giraffe_022',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_022_01',
  },
  {
    id: 'giraffe_023',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_023_01',
  },
  {
    id: 'giraffe_024',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_024_01',
  },
  {
    id: 'giraffe_025',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_025_01',
  },
  {
    id: 'giraffe_026',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_026_01',
  },
  {
    id: 'giraffe_027',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_027_01',
  },
  {
    id: 'giraffe_028',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_028_01',
  },
  {
    id: 'giraffe_029',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_029_01',
  },
  {
    id: 'giraffe_030',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_030_01',
  },
  {
    id: 'giraffe_031',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_031_01',
  },
  {
    id: 'giraffe_032',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_032_01',
  },
  {
    id: 'giraffe_033',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_033_01',
  },
  {
    id: 'giraffe_034',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_034_01',
  },
  {
    id: 'giraffe_035',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_035_01',
  },
  {
    id: 'giraffe_036',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_036_01',
  },
  {
    id: 'giraffe_037',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_037_01',
  },
  {
    id: 'giraffe_038',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_038_01',
  },
  {
    id: 'giraffe_039',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_039_01',
  },
  {
    id: 'giraffe_040',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_040_01',
  },
  {
    id: 'giraffe_041',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_041_01',
  },
  {
    id: 'giraffe_042',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['normal', 'happy'],
    script_id: 'giraffe_042_01',
  },
  {
    id: 'giraffe_043',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_043_01',
  },
  {
    id: 'giraffe_044',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_044_01',
  },
  {
    id: 'giraffe_045',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_045_01',
  },
  {
    id: 'giraffe_046',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_046_01',
  },
  {
    id: 'giraffe_047',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_047_01',
  },
  {
    id: 'giraffe_048',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_048_01',
  },
  {
    id: 'giraffe_049',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_049_01',
  },
  {
    id: 'giraffe_050',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_050_01',
  },
  {
    id: 'giraffe_051',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_051_01',
  },
  {
    id: 'giraffe_052',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_052_01',
  },
  {
    id: 'giraffe_053',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_053_01',
  },
  {
    id: 'giraffe_054',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_054_01',
  },
  {
    id: 'giraffe_055',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_055_01',
  },
  {
    id: 'giraffe_056',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_056_01',
  },
  {
    id: 'giraffe_057',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_057_01',
  },
  {
    id: 'giraffe_058',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_058_01',
  },
  {
    id: 'giraffe_059',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_059_01',
  },
  {
    id: 'giraffe_060',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_060_01',
  },
  {
    id: 'giraffe_061',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_061_01',
  },
  {
    id: 'giraffe_062',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_062_01',
  },
  {
    id: 'giraffe_063',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['happy'],
    script_id: 'giraffe_063_01',
  },
  {
    id: 'giraffe_064',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'giraffe_064_01',
  },
  {
    id: 'giraffe_065',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['hungry'],
    script_id: 'giraffe_065_01',
  },
  {
    id: 'giraffe_066',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'giraffe_066_01',
  },
  {
    id: 'giraffe_067',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_hungry'],
    script_id: 'giraffe_067_01',
  },
  {
    id: 'giraffe_068',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'giraffe_068_01',
  },
  {
    id: 'giraffe_069',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dirty'],
    script_id: 'giraffe_069_01',
  },
  {
    id: 'giraffe_070',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'giraffe_070_01',
  },
  {
    id: 'giraffe_071',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_dirty'],
    script_id: 'giraffe_071_01',
  },
  {
    id: 'giraffe_072',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'giraffe_072_01',
  },
  {
    id: 'giraffe_073',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['lonely'],
    script_id: 'giraffe_073_01',
  },
  {
    id: 'giraffe_074',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'giraffe_074_01',
  },
  {
    id: 'giraffe_075',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_lonely'],
    script_id: 'giraffe_075_01',
  },
  {
    id: 'giraffe_076',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'giraffe_076_01',
  },
  {
    id: 'giraffe_077',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['pee'],
    script_id: 'giraffe_077_01',
  },
  {
    id: 'giraffe_078',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'giraffe_078_01',
  },
  {
    id: 'giraffe_079',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['very_pee'],
    script_id: 'giraffe_079_01',
  },
  {
    id: 'giraffe_080',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'giraffe_080_01',
  },
  {
    id: 'giraffe_081',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['scared'],
    script_id: 'giraffe_081_01',
  },
  {
    id: 'giraffe_082',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'giraffe_082_01',
  },
  {
    id: 'giraffe_083',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sick'],
    script_id: 'giraffe_083_01',
  },
  {
    id: 'giraffe_084',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'giraffe_084_01',
  },
  {
    id: 'giraffe_085',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['tooth_decay'],
    script_id: 'giraffe_085_01',
  },
  {
    id: 'giraffe_086',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['sleeping'],
    script_id: 'giraffe_086_01',
  },
  {
    id: 'giraffe_087',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['dead'],
    script_id: 'giraffe_087_01',
  },
  {
    id: 'giraffe_088',
    pet_id: 'giraffe',
    scenes: ['normal_chat', 'friend_chat'],
    pet_states: ['dying'],
    script_id: 'giraffe_088_01',
  },
  {
    id: 'giraffe_089',
    pet_id: 'giraffe',
    scenes: ['normal_chat'],
    pet_states: ['want_to_go_out'],
    script_id: 'giraffe_089_01',
  },
  {
    id: 'giraffe_090',
    pet_id: 'giraffe',
    scenes: ['had_visitor'],
    script_id: 'giraffe_090_01',
  },
  {
    id: 'giraffe_091',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['scream_danger'],
    script_id: 'giraffe_091_01',
  },
  {
    id: 'giraffe_092',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['best_word'],
    script_id: 'giraffe_092_01',
  },
  {
    id: 'giraffe_093',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['memorable_gift'],
    script_id: 'giraffe_093_01',
  },
  {
    id: 'giraffe_094',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['similar_animal'],
    script_id: 'giraffe_094_01',
  },
  {
    id: 'giraffe_095',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['special_strength'],
    script_id: 'giraffe_095_01',
  },
  {
    id: 'giraffe_096',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_motto'],
    script_id: 'giraffe_096_01',
  },
  {
    id: 'giraffe_097',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['favorite_band'],
    script_id: 'giraffe_097_01',
  },
  {
    id: 'giraffe_098',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['interesting_book'],
    script_id: 'giraffe_098_01',
  },
  {
    id: 'giraffe_099',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['worst_thing'],
    script_id: 'giraffe_099_01',
  },
  {
    id: 'giraffe_100',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['good_act'],
    script_id: 'giraffe_100_01',
  },
  {
    id: 'giraffe_101',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['dog_cat'],
    script_id: 'giraffe_101_01',
  },
  {
    id: 'giraffe_102',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['mind_future'],
    script_id: 'giraffe_102_01',
  },
  {
    id: 'giraffe_103',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['time_money'],
    script_id: 'giraffe_103_01',
  },
  {
    id: 'giraffe_104',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['playing_hookey'],
    script_id: 'giraffe_104_01',
  },
  {
    id: 'giraffe_105',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['friends_lover'],
    script_id: 'giraffe_105_01',
  },
  {
    id: 'giraffe_106',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['arm_power'],
    script_id: 'giraffe_106_01',
  },
  {
    id: 'giraffe_107',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['until_end'],
    script_id: 'giraffe_107_01',
  },
  {
    id: 'giraffe_108',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['spendthrift'],
    script_id: 'giraffe_108_01',
  },
  {
    id: 'giraffe_109',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['propose_wait'],
    script_id: 'giraffe_109_01',
  },
  {
    id: 'giraffe_110',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['consult'],
    script_id: 'giraffe_110_01',
  },
  {
    id: 'giraffe_111',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['bad_boy'],
    script_id: 'giraffe_111_01',
  },
  {
    id: 'giraffe_112',
    pet_id: 'giraffe',
    scenes: ['friend_chat'],
    pet_states: ['happy'],
    req_answers: ['teacher_like'],
    script_id: 'giraffe_112_01',
  },
  {
    id: 'giraffe_113',
    pet_id: 'giraffe',
    scenes: ['initial_greetings'],
    script_id: 'giraffe_113_01',
  },
  {
    id: 'giraffe_114',
    pet_id: 'giraffe',
    scenes: ['friend_greetings'],
    script_id: 'giraffe_114_01',
  },
  {
    id: 'giraffe_115',
    pet_id: 'giraffe',
    scenes: ['friend_welcome'],
    script_id: 'giraffe_115_01',
  },
  {
    id: 'giraffe_116',
    pet_id: 'giraffe',
    scenes: ['friend_appreciation'],
    script_id: 'giraffe_116_01',
  },
  {
    id: 'giraffe_117',
    pet_id: 'giraffe',
    scenes: ['friend_goodby'],
    script_id: 'giraffe_117_01',
  },
  {
    id: 'giraffe_118',
    pet_id: 'giraffe',
    scenes: ['friend_farewell'],
    script_id: 'giraffe_118_01',
  },
  {
    id: 'giraffe_119',
    pet_id: 'giraffe',
    scenes: ['friend_kickedout'],
    script_id: 'giraffe_119_01',
  },
  {
    id: 'giraffe_120',
    pet_id: 'giraffe',
    scenes: ['care_action_blocker'],
    pet_states: ['scared'],
    script_id: 'giraffe_120_01',
  },
  {
    id: 'giraffe_121',
    pet_id: 'giraffe',
    scenes: ['care_action_blocker'],
    pet_states: ['tooth_decay'],
    script_id: 'giraffe_121_01',
  },
  {
    id: 'giraffe_122',
    pet_id: 'giraffe',
    scenes: ['care_action_blocker'],
    pet_states: ['dying'],
    script_id: 'giraffe_122_01',
  },
  {
    id: 'giraffe_123',
    pet_id: 'giraffe',
    scenes: ['care_action_blocker'],
    pet_states: ['want_to_go_out'],
    script_id: 'giraffe_123_01',
  },
  {
    id: 'giraffe_124',
    pet_id: 'giraffe',
    scenes: ['cured'],
    pet_states: ['sick'],
    script_id: 'giraffe_124_01',
  },
  {
    id: 'giraffe_125',
    pet_id: 'giraffe',
    scenes: ['cured'],
    pet_states: ['tooth_decay'],
    script_id: 'giraffe_125_01',
  },
  {
    id: 'giraffe_126',
    pet_id: 'giraffe',
    scenes: ['cured'],
    pet_states: ['dying'],
    script_id: 'giraffe_126_01',
  },
  {
    id: 'giraffe_127',
    pet_id: 'giraffe',
    scenes: ['not_cured'],
    pet_states: ['sick'],
    script_id: 'giraffe_127_01',
  },
  {
    id: 'giraffe_128',
    pet_id: 'giraffe',
    scenes: ['not_cured'],
    pet_states: ['tooth_decay'],
    script_id: 'giraffe_128_01',
  },
  {
    id: 'giraffe_129',
    pet_id: 'giraffe',
    scenes: ['not_cured'],
    pet_states: ['dying'],
    script_id: 'giraffe_129_01',
  },
  {
    id: 'giraffe_130',
    pet_id: 'giraffe',
    scenes: ['duo_inviter_invite'],
    script_id: 'giraffe_130_01',
  },
  {
    id: 'giraffe_131',
    pet_id: 'giraffe',
    scenes: ['duo_invitee_invited'],
    script_id: 'giraffe_131_01',
  },
  {
    id: 'giraffe_132',
    pet_id: 'giraffe',
    scenes: ['duo_inviter_home'],
    script_id: 'giraffe_132_01',
  },
  {
    id: 'giraffe_133',
    pet_id: 'giraffe',
    scenes: ['duo_invitee_home'],
    script_id: 'giraffe_133_01',
  },
  {
    id: 'giraffe_134',
    pet_id: 'giraffe',
    scenes: ['duo_inviter_notified'],
    script_id: 'giraffe_134_01',
  },
  {
    id: 'giraffe_135',
    pet_id: 'giraffe',
    scenes: ['duo_invitee_answer'],
    script_id: 'giraffe_135_01',
  },
  {
    id: 'giraffe_136',
    pet_id: 'giraffe',
    scenes: ['duo_invitee_accept'],
    script_id: 'giraffe_136_01',
  },
  {
    id: 'giraffe_137',
    pet_id: 'giraffe',
    scenes: ['duo_invitee_refuse'],
    script_id: 'giraffe_137_01',
  },
  {
    id: 'giraffe_138',
    pet_id: 'giraffe',
    scenes: ['duo_invitee_message_intro'],
    script_id: 'giraffe_138_01',
  },
  {
    id: 'giraffe_139',
    pet_id: 'giraffe',
    scenes: ['duo_invitee_message'],
    script_id: 'giraffe_139_01',
  },
  {
    id: 'giraffe_140',
    pet_id: 'giraffe',
    scenes: ['duo_inviter_refused'],
    script_id: 'giraffe_140_01',
  },
];
